import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39cd9ca5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newCustomResource" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "total" }
const _hoisted_5 = { class: "divide" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总客户数:", -1))
const _hoisted_7 = { class: "inner_number" }
const _hoisted_8 = { class: "total" }
const _hoisted_9 = { class: "divide" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞1条:", -1))
const _hoisted_11 = { class: "inner_number_reply" }
const _hoisted_12 = { class: "divide" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_14 = { class: "inner_number_reply" }
const _hoisted_15 = { class: "total" }
const _hoisted_16 = { class: "divide" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞3条:", -1))
const _hoisted_18 = { class: "inner_number_reply" }
const _hoisted_19 = { class: "divide" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_21 = { class: "inner_number_reply" }
const _hoisted_22 = { class: "total" }
const _hoisted_23 = { class: "divide" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞5条:", -1))
const _hoisted_25 = { class: "inner_number_reply" }
const _hoisted_26 = { class: "divide" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_28 = { class: "inner_number_reply" }
const _hoisted_29 = { class: "total" }
const _hoisted_30 = { class: "divide" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复＞10条:", -1))
const _hoisted_32 = { class: "inner_number_reply" }
const _hoisted_33 = { class: "divide" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_35 = { class: "inner_number_reply" }
const _hoisted_36 = { class: "total" }
const _hoisted_37 = { class: "divide" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当天删除:", -1))
const _hoisted_39 = { class: "inner_number_delete" }
const _hoisted_40 = { class: "divide" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_42 = { class: "inner_number_delete" }
const _hoisted_43 = { class: "total" }
const _hoisted_44 = { class: "divide" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一周内删除:", -1))
const _hoisted_46 = { class: "inner_number_delete" }
const _hoisted_47 = { class: "divide" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比:", -1))
const _hoisted_49 = { class: "inner_number_delete" }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "export-task-footer" }

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import {
  downloadData,
  getListData,
  getPageListData,
  queryStatistical
} from '@/service/main/system'
import { secondToString } from '@/utils/date-format'
import { onBeforeUnmount, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { usePermission } from '@/hooks/usePermission'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
interface ExportTask {
  createdAt: string
  errorMessage: string
  failedCount: number
  fileName: string
  finishedAt: string
  status: 'PENDING' | 'RUNNING' | 'SUCCESS' | 'FAILED' | 'EXPIRED'
  successCount: number
  taskId: string
  totalCount: number
}

type ExportTaskResponse = Omit<
  ExportTask,
  'successCount' | 'failedCount' | 'totalCount'
> & {
  successCount: string
  failedCount: string
  totalCount: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Statistic',
  setup(__props) {

dayjs.locale('zh-cn')

const store = useStore()
const canViewExportTasks =
  usePermission('newCustomResource', 'download') ||
  usePermission('newCustomResource', 'downloadData')

initEmptyParam()
const userInfo = store.state.login.userInfo
let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    date: [getBeforeDate('7_days'), new Date().toISOString().slice(0, 10)],
    usedBy: userInfo.realName,
    pageNo: 1,
    pageSize: 10
  }
} else {
  queryParam.value = {
    date: [getBeforeDate('7_days'), new Date().toISOString().slice(0, 10)],
    pageNo: 1,
    pageSize: 10
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)
const statitiscal = ref({
  totalCount: 0,
  replyOneCount: 0,
  replyOnePercent: '0%',
  replyThreeCount: 0,
  replyThreePercent: '0%',
  replyFiveCount: 0,
  replyFivePercent: '0%',
  replyTenCount: 0,
  replyTenPercent: '0%',
  dayDeleteCount: 0,
  dayDeletePercent: '0%',
  weekDeleteCount: 0,
  weekDeletePercent: '0%',
  funds0wTo5wCount: 0,
  funds0wTo5wPercent: '0%',
  funds5wTo10wCount: 0,
  funds5wTo10wPercent: '0%',
  funds10wCount: 0,
  funds10wPercent: '0%'
})
const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistical(
    '/main/newCustomResourceV2/querySummary',
    item
  )
}

searchCb(queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const getUsedBy = async () => {
  let userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const userOptions = userList.map((item: any) => {
    return {
      title: item.userName,
      value: item.userName
    }
  })
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userOptions
}
getUsedBy()

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', {
    ...formData,
    pageNo: store.state.system.queryInfo.pageNo,
    pageSize: store.state.system.queryInfo.pageSize
  })
}

const submitExportLoading = ref(false)
const exportTaskDialogVisible = ref(false)
const exportTaskLoading = ref(false)
const downloadingTaskId = ref('')
const exportTasks = ref<ExportTask[]>([])
const exportTaskTotal = ref(0)
const exportTaskPage = ref({
  pageNo: 1,
  pageSize: 10
})
let exportTaskTimer: number | undefined

const stopExportTaskPolling = () => {
  if (exportTaskTimer !== undefined) {
    window.clearInterval(exportTaskTimer)
    exportTaskTimer = undefined
  }
}

const updateExportTaskPolling = () => {
  const hasProcessingTask = exportTasks.value.some(
    (task) => task.status === 'PENDING' || task.status === 'RUNNING'
  )

  if (!exportTaskDialogVisible.value || !hasProcessingTask) {
    stopExportTaskPolling()
    return
  }

  if (exportTaskTimer === undefined) {
    exportTaskTimer = window.setInterval(loadExportTasks, 5000)
  }
}

const handleSubmitExport = async () => {
  submitExportLoading.value = true
  try {
    await getListData('/main/newCustomResourceV2/download', {
      ...store.state.system.queryInfo,
      ...store.state.system.orderInfo
    })
    ElMessage.success('导出任务提交成功')
  } finally {
    submitExportLoading.value = false
  }
}

const loadExportTasks = async () => {
  if (exportTaskLoading.value) return
  exportTaskLoading.value = true
  try {
    const data = await getPageListData(
      '/main/newCustomResourceV2/exportTasks',
      exportTaskPage.value
    )
    exportTasks.value = data.list.map((task: ExportTaskResponse) => ({
      ...task,
      successCount: Number(task.successCount),
      failedCount: Number(task.failedCount),
      totalCount: Number(task.totalCount)
    }))
    exportTaskTotal.value = Number(data.total)
    updateExportTaskPolling()
  } finally {
    exportTaskLoading.value = false
  }
}

const startExportTaskPolling = () => {
  stopExportTaskPolling()
  loadExportTasks()
}

const openExportTaskDialog = () => {
  exportTaskDialogVisible.value = true
}

const handleExportTaskPageSizeChange = (pageSize: number) => {
  exportTaskPage.value = { pageNo: 1, pageSize }
  loadExportTasks()
}

const handleExportTaskPageChange = (pageNo: number) => {
  exportTaskPage.value.pageNo = pageNo
  loadExportTasks()
}

const exportTaskStatusMap = {
  PENDING: { text: '等待执行', type: 'warning' },
  RUNNING: { text: '正在生成', type: '' },
  SUCCESS: { text: '生成成功', type: 'success' },
  FAILED: { text: '生成失败', type: 'danger' },
  EXPIRED: { text: '已过期', type: 'info' }
} as const
const formatDateTime = (value: string) => {
  if (!value) return ''
  const matched = value.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/)
  if (matched) return `${matched[1]} ${matched[2]}`
  const date = dayjs(value)
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : value
}
const handleDownloadExportTask = async (task: ExportTask) => {
  downloadingTaskId.value = task.taskId
  try {
    const data = await downloadData(
      `/main/newCustomResourceV2/exportTasks/${task.taskId}/file`,
      {},
      'blob'
    )
    const blobUrl = URL.createObjectURL(
      new Blob([data], { type: 'application/octet-stream' })
    )
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = task.fileName
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(blobUrl)
    document.body.removeChild(link)
  } finally {
    downloadingTaskId.value = ''
  }
}

onBeforeUnmount(stopExportTaskPolling)

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.corPid }
  })
}

getCompanyList()

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(
  resetCb,
  searchCb
)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("em", _hoisted_7, _toDisplayString(statitiscal.value && statitiscal.value.totalCount ? statitiscal.value.totalCount : 0), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("em", _hoisted_11, _toDisplayString(statitiscal.value && statitiscal.value.replyOneCount
                ? statitiscal.value.replyOneCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("em", _hoisted_14, _toDisplayString(statitiscal.value && statitiscal.value.replyOnePercent
                ? statitiscal.value.replyOnePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("em", _hoisted_18, _toDisplayString(statitiscal.value && statitiscal.value.replyThreeCount
                ? statitiscal.value.replyThreeCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("em", _hoisted_21, _toDisplayString(statitiscal.value && statitiscal.value.replyThreePercent
                ? statitiscal.value.replyThreePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("em", _hoisted_25, _toDisplayString(statitiscal.value && statitiscal.value.replyFiveCount
                ? statitiscal.value.replyFiveCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("em", _hoisted_28, _toDisplayString(statitiscal.value && statitiscal.value.replyFivePercent
                ? statitiscal.value.replyFivePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("em", _hoisted_32, _toDisplayString(statitiscal.value && statitiscal.value.replyTenCount
                ? statitiscal.value.replyTenCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("em", _hoisted_35, _toDisplayString(statitiscal.value && statitiscal.value.replyTenPercent
                ? statitiscal.value.replyTenPercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("em", _hoisted_39, _toDisplayString(statitiscal.value && statitiscal.value.dayDeleteCount
                ? statitiscal.value.dayDeleteCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("em", _hoisted_42, _toDisplayString(statitiscal.value && statitiscal.value.dayDeletePercent
                ? statitiscal.value.dayDeletePercent
                : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("em", _hoisted_46, _toDisplayString(statitiscal.value && statitiscal.value.weekDeleteCount
                ? statitiscal.value.weekDeleteCount
                : 0), 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("em", _hoisted_49, _toDisplayString(statitiscal.value && statitiscal.value.weekDeletePercent
                ? statitiscal.value.weekDeletePercent
                : '-'), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "newCustomResource",
      pageUrl: "/main/newCustomResourceV2/queryPage",
      hideDownloadButton: ""
    }, {
      headerHandler: _withCtx(() => [
        (_unref(canViewExportTasks))
          ? (_openBlock(), _createBlock(_component_el_button_group, {
              key: 0,
              class: "export-actions"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "medium",
                  loading: submitExportLoading.value,
                  onClick: handleSubmitExport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 提交下载 ")
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "medium",
                  icon: "el-icon-document",
                  title: "下载列表",
                  "aria-label": "下载列表",
                  onClick: openExportTaskDialog
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(_component_el_dialog, {
      modelValue: exportTaskDialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((exportTaskDialogVisible).value = $event)),
      title: "导出任务",
      width: "min(92vw, 980px)",
      "destroy-on-close": "",
      onOpen: startExportTaskPolling,
      onClosed: stopExportTaskPolling
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_51, [
          _createVNode(_component_el_pagination, {
            "current-page": exportTaskPage.value.pageNo,
            "page-size": exportTaskPage.value.pageSize,
            "page-sizes": [10, 20, 30, 50],
            layout: "total, sizes, prev, pager, next",
            total: exportTaskTotal.value,
            onSizeChange: handleExportTaskPageSizeChange,
            onCurrentChange: handleExportTaskPageChange
          }, null, 8, ["current-page", "page-size", "total"]),
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (exportTaskDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "element-loading-text": "加载中...",
          "empty-text": exportTaskLoading.value ? '加载中...' : '暂无数据',
          data: exportTasks.value,
          border: "",
          stripe: "",
          "max-height": "440"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "fileName",
              label: "文件名",
              "min-width": "180"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.fileName || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: exportTaskStatusMap[scope.row.status].type
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(exportTaskStatusMap[scope.row.status].text), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "进度",
              width: "120",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.successCount + scope.row.failedCount) + " / " + _toDisplayString(scope.row.totalCount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              label: "提交时间",
              "min-width": "165"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatDateTime(scope.row.createdAt) || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "finishedAt",
              label: "完成时间",
              "min-width": "165"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatDateTime(scope.row.finishedAt)|| '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "errorMessage",
              label: "失败原因",
              "min-width": "180"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.errorMessage || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "80",
              fixed: "right",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status === 'SUCCESS')
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: "下载文件",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "text",
                          icon: "el-icon-download",
                          loading: downloadingTaskId.value === scope.row.taskId,
                          "aria-label": "下载文件",
                          onClick: ($event: any) => (handleDownloadExportTask(scope.row))
                        }, null, 8, ["loading", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createElementBlock("span", _hoisted_50, "-"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["empty-text", "data"])), [
          [_directive_loading, exportTaskLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})